import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { getPathWithQuery } from '../../../../helpers/providers/shared';

export const useHashing = () => {
  const { query, pathname, push } = useRouter();

  const handleHashing = useCallback(
    (hashValue: string | undefined) => {
      push(
        {
          pathname,
          query: {
            ...query,
          },
          hash: hashValue,
        },
        window?.location?.pathname
          ? getPathWithQuery(window?.location?.pathname, query, hashValue)
          : getPathWithQuery(pathname, query, hashValue),
        { shallow: true },
      );
    },
    [query, pathname],
  );
  return {
    handleHashing,
  };
};
